import React from "react";

function PageTitle(props: Readonly<{ title: string }>) {
  return (
    <div>
      <p className=" pt-[5%] pl-[5%] pb-[2%] text-4xl md:text-5xl lg:text-6xl 2xl:text-7xl">
        {props.title}
      </p>
    </div>
  );
}

export default PageTitle;
